export { default as VictoryVoronoi } from "./victory-voronoi";
export { default as Voronoi } from "./voronoi";


//////////////////
// WEBPACK FOOTER
// ./~/victory-voronoi/es/index.js
// module id = ./node_modules/victory-voronoi/es/index.js
// module chunks = 1